import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { LocationAllowedOsUpdateStoreActions } from '../location-allowed-os-updates/index';

import { LocationsRouterStoreSelectors } from '../router/index';

@Injectable({ providedIn: 'root' })
export class LocationAllowedOsUpdateResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectLocationId).pipe(
      filter((x): x is string => !!x),
      tap((locationId) => {
        this.store.dispatch(
          LocationAllowedOsUpdateStoreActions.LocationAllowedOsUpdatesResolverActions.requested({
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
